import { useCallback, useEffect, useState } from 'react';
import StorageService from '../services/StorageService';

const STORAGE_KEY = 'voipLastRecentsViewedAt';

/**
 * Tracks the last time the user opened the VoIP Recents tab. Used to decide
 * which missed/no-answer calls count as "new" for the notification badge.
 * Persisted in localStorage per browser (see StorageService).
 */
export default function useLastRecentsViewedAt() {
  const [lastViewedAtMs, setLastViewedAtMs] = useState(() => {
    const raw = StorageService.readEntry(STORAGE_KEY);
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? n : 0;
  });

  // Stay in sync if another tab updates the value
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY) {
        const n = Number(e.newValue);
        setLastViewedAtMs(Number.isFinite(n) && n > 0 ? n : 0);
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const markViewedNow = useCallback(() => {
    const now = Date.now();
    StorageService.createEntry(STORAGE_KEY, String(now));
    setLastViewedAtMs(now);
  }, []);

  return { lastViewedAtMs, markViewedNow };
}
